export const scaffoldStatusIds: { [key: string]: string } = {
  incomplete: '218cc6f7-7dcf-4438-a1f2-d0a92cddd84f',
  onHire: '47a83b47-590f-4f21-839d-904d696d6f66',
  offHire: '6f4f2e80-0ac8-4dc5-83e2-90511f0a7ef8',
  dismantled: 'b37f6451-4d79-4339-8834-d8694192474b'
};
